// Todo: move this to global state
function getData() {
    var venueInfo = {
        privateEvent: {
            id: 1,
            venueTitle: "Private Event",
            venueUrl: "",
            address: "",
            mapUrl: "",
            city: "",
        },
        bayviewWildWoodResort: {
            id: 2,
            venueTitle: "Bayview Wildwood Resort",
            venueUrl: "https://www.bayviewwildwood.com/",
            address: "1500 Port Stanton Pkwy, Severn Bridge, ON",
            mapUrl: "Bayview+Wildwood+Resort,+Ascend+Hotel+Collection/@44.7968828,-79.4109819,17z/data=!4m9!3m8!1s0x4d2aa3a0f39f30bf:0x75e6d17205eb04ef!5m2!4m1!1i2!8m2!3d44.796879!4d-79.408407!16s%2Fg%2F1tcxtwjq",
            city: "Severn Bridge",
        },
        bullPubAndGrill: {
            id: 3,
            venueTitle: "The Bull Pub and Grill Whitby",
            venueUrl: "https://www.thebullpubandgrill.ca/locations/whitby",
            address: "112 Colborne St E, Whitby, ON L1N 1V8",
            mapUrl: "The+Bull+Pub+%26+Grill/@43.8792657,-78.9434424,17z/data=!3m1!4b1!4m6!3m5!1s0x89d51fd1cc73557b:0x4cc71ccf4127c998!8m2!3d43.8792657!4d-78.9408675!16s%2Fg%2F11w3mn_35c?entry=ttu&g_ep=EgoyMDI1MDgxMy4wIKXMDSoASAFQAw%3D%3D",
            city: "Whitby",
        },
        colonelMustards: {
            id: 4,
            venueTitle: "Colonel Mustards Bar & Grill",
            venueUrl: "http://www.colmustards.ca/",
            address: "16925 Yonge St, Newmarket, ON",
            mapUrl: "Col.+Mustard’s+Bar+%26+Grill/@44.0408747,-79.4785003,17z/data=!3m1!4b1!4m6!3m5!1s0x882ad18bffbfffff:0xf56f3dc66c3d415b!8m2!3d44.0408709!4d-79.4759254!16s%2Fg%2F11y3v1rd6_",
            city: "Newmarket",
        },
        earlOfWhitchurch: {
            id: 5,
            venueTitle: "The Earl of Whitchurch",
            venueUrl: "http://www.shamrockswhitby.com/",
            address: "6204 Main St, Whitchurch-Stouffville, ON",
            mapUrl: "Earl+Of+Whitchurch/@43.9710443,-79.2516985,16z/data=!3m1!4b1!4m6!3m5!1s0x89d52ed4413998cb:0x2700e742f1cdca22!8m2!3d43.9710405!4d-79.2491236!16s%2Fg%2F1w0h8hhf",
            city: "Whitchurch - Stouffville",
        },
        georgianBayPark: {
            id: 6,
            venueTitle: "Georgian Bay Park",
            venueUrl: "https://georgianbaypark.com/",
            address: "4230 Crossland Rd, Tiny, ON L0L 1P1",
            mapUrl: "Georgian+Bay+Park/@44.6009068,-79.9844062,17z/data=!3m1!4b1!4m6!3m5!1s0x4d2ad3998afa3a8f:0x8dd5d7e89e02c9d1!8m2!3d44.600903!4d-79.9818313!16s%2Fg%2F11dfjwpvhp",
            city: "Tiny",
        },
        hillsPubAndGrill: {
            id: 7,
            venueTitle: "Hills Pub and Grill",
            venueUrl: "https://hillspub.ca/",
            address: "250 Taunton Rd E, Oshawa, ON L1G 6Z3",
            mapUrl: "The+Rumour+Mill/@43.9356298,-78.8734131,17z/data=!3m1!4b1!4m6!3m5!1s0x89d51bc2a56e28d3:0xb7b4efbe38a07214!8m2!3d43.935626!4d-78.8708382!16s%2Fg%2F11p106h1d3",
            city: "Oshawa",
        },
        linsmoreTavern: {
            id: 8,
            venueTitle: "Linsmore Tavern",
            venueUrl: "https://www.linsmoretavern.com/",
            address: "1298 Danforth Ave, Toronto, ON M4J 1M6",
            mapUrl: "",
            city: "Toronto",
        },
        lionAndUnicorn: {
            id: 9,
            venueTitle: "Lion & Unicorn",
            venueUrl: "http://www.lionandunicorn.ca/",
            address: "965 Dundas St W, Whitby, ON",
            mapUrl: "The+Lion+%26+Unicorn+-+Bar+%26+Grill/@43.8748456,-78.9652524,17z/data=!3m2!4b1!5s0x89d51e3aafaedcaf:0xaddaf8e7cb8b0da3!4m6!3m5!1s0x89d51e3aa6c96087:0xc6fe18c7fa45b434!8m2!3d43.8748418!4d-78.9626775!16s%2Fg%2F11b_2s34ql",
            city: "Whitby",
        },
        malones: {
            id: 10,
            venueTitle: "Malones Pint House",
            venueUrl: "https://malonesph.ca/",
            address: "118 Bradford St, Barrie, ON",
            mapUrl: "Malones+Pint+House/@44.3815648,-79.6965627,16z/data=!3m1!4b1!4m6!3m5!1s0x882abcd5be59b947:0x2c1c356936a41d8a!8m2!3d44.381561!4d-79.6939878!16s%2Fg%2F1tm8l6b4",
            city: "Barrie",
        },
        pearsonPub: {
            id: 11,
            venueTitle: "The Pearson Pub",
            venueUrl: "https://thepearsonpubwhitby.ca/",
            address: "101 Mary St W, Whitby, ON L1N 4H4",
            mapUrl: "maps/place/The+Pearson+Pub/@43.8826961,-78.9512613,17z/data=!3m1!5s0x89d51e132bf5ae99:0x214c5be617e43ff3!4m6!3m5!1s0x89d51e6d2b1b3253:0x5328228ae5ab41cb!8m2!3d43.8815439!4d-78.9429464!16s%2Fg%2F1tk68nwz?entry=ttu&g_ep=EgoyMDI1MDYwNC4wIKXMDSoASAFQAw%3D%3D",
            city: "Whitby",
        },
        rumourMill: {
            id: 12,
            venueTitle: "The Rumour Mill Bar and Grill",
            venueUrl: "https://rumourmillbar.ca/",
            address: "250 Taunton Rd E, Oshawa, ON L1G 6Z3",
            mapUrl: "The+Rumour+Mill/@43.9356298,-78.8734131,17z/data=!3m1!4b1!4m6!3m5!1s0x89d51bc2a56e28d3:0xb7b4efbe38a07214!8m2!3d43.935626!4d-78.8708382!16s%2Fg%2F11p106h1d3",
            city: "Oshawa",
        },
        shamRocks: {
            id: 13,
            venueTitle: "Sham Rock’s Pub & Grill House",
            venueUrl: "http://www.shamrockswhitby.com/",
            address: "1100 Dundas St E, Whitby, ON",
            mapUrl: "Sham+Rock's+Grill+House/@43.8841739,-78.9270806,17z/data=!3m1!4b1!4m6!3m5!1s0x89d51ddeaa1660b3:0x6d5782873f9d4415!8m2!3d43.8841701!4d-78.9245057!16s%2Fg%2F1trrf5ph",
            city: "Whitby",
        }
    }

    var events = [
        {
            id: 67,
            title: "Salty Rocks the Pearson Pub",
            date: new Date("November 28, 2026 21:30:00"),
            venue: venueInfo.pearsonPub,
            description: "",
        },      
        {
            id: 66,
            title: "Private Event",
            date: new Date("September 5, 2026 19:00:00"),
            venue: venueInfo.privateEvent,
            description: "",
        },
        {
            id: 65,
            title: "Salty Summertime Rock at the Pearson Pub",
            date: new Date("July 25, 2026 21:30:00"),
            venue: venueInfo.pearsonPub,
            description: "",
        },
        {
            id: 64,
            title: "Private Event",
            date: new Date("July 12, 2026 15:00:00"),
            venue: venueInfo.privateEvent,
            description: "",
        },
        {
            id: 63,
            title: "Salty Spring Bash at the Pearson Pub",
            date: new Date("May 30, 2026 21:30:00"),
            venue: venueInfo.pearsonPub,
            description: "",
        },
        {
            id: 62,
            title: "We are all Salty at Malones",
            date: new Date("May 2, 2026 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 61,
            title: "April Fools w/ Salty @ The Rumour Mill",
            date: new Date("April 4, 2026 21:00:00"),
            venue: venueInfo.rumourMill,
            description: "",
        },
        {
            id: 60,
            title: "Salty Returns to Malones",
            date: new Date("March 27, 2026 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 59,
            title: "Get Salty at the Pearson Pub!",
            date: new Date("March 7, 2026 21:30:00"),
            venue: venueInfo.pearsonPub,
            description: "",
        },
        {
            id: 58,
            title: "Salty at the legendary Linsmore Tavern",
            date: new Date("February 19, 2026 21:00:00"),
            venue: venueInfo.linsmoreTavern,
            description: "",
        },
        {
            id: 57,
            title: "Salt the roads to the Pearson Pub!",
            date: new Date("February 7, 2026 21:30:00"),
            venue: venueInfo.pearsonPub,
            description: "",
        },
        {
            id: 56,
            title: "2026 is SALTY!",
            date: new Date("January 24, 2026 21:00:00"),
            venue: venueInfo.rumourMill,
            description: "",
        },
        {
            id: 55,
            title: "We've got your Salt right here!!!",
            date: new Date("December 13, 2025 21:00:00"),
            venue: venueInfo.rumourMill,
            description: "",
        },
        {
            id: 54,
            title: "Salty September",
            date: new Date("September 26, 2025 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 53,
            title: "Salty and the Bull",
            date: new Date("September 13, 2025 21:00:00"),
            venue: venueInfo.bullPubAndGrill,
            description: "",
        },
        {
            id: 52,
            title: "Let's get SALTY at the Pearson Pub",
            date: new Date("August 29, 2025 21:30:00"),
            venue: venueInfo.pearsonPub,
            description: "",
        },
        {
            id: 51,
            title: "Malones Presents Salty's 50th Gig Celebration!",
            date: new Date("July 26, 2025 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 50,
            title: "Pearson Pub: Introducing SALTY",
            date: new Date("July 4, 2025 21:30:00"),
            venue: venueInfo.pearsonPub,
            description: "",
        },
        {
            id: 49,
            title: "Salty as $@*#! at The Rumour Mill Bar and Grill",
            date: new Date("April 5, 2025 21:00:00"),
            venue: venueInfo.rumourMill,
            description: "",
        },
        {
            id: 48,
            title: "Salty @ Malones",
            date: new Date("Dec 13, 2024 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 47,
            title: "Salty November @ The Rumour Mill Bar and Grill",
            date: new Date("November 15, 2024 21:00:00"),
            venue: venueInfo.rumourMill,
            description: "",
        },
        {
            id: 46,
            title: "OctoberSalt @ The Rumour Mill Bar and Grill",
            date: new Date("October 5, 2024 21:00:00"),
            venue: venueInfo.rumourMill,
            description: "",
        },
        {
            id: 45,
            title: "August Rock Bash w/ Salty @ Rumours",
            date: new Date("August 9, 2024 21:00:00"),
            venue: venueInfo.rumourMill,
            description: "",
        },
        {
            id: 44,
            title: "Summer Salt at Malones",
            date: new Date("July 19, 2024 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 43,
            title: "May TWO-FOUR + 1 with Salty at Rumours",
            date: new Date("May 25, 2024 21:00:00"),
            venue: venueInfo.rumourMill,
            description: "",
        },
        {
            id: 42,
            title: "Fool April with Salty at Malones",
            date: new Date("April 12, 2024 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 41,
            title: "#getsalty at Hills",
            date: new Date("March 29, 2024 21:00:00"),
            venue: venueInfo.hillsPubAndGrill,
            description: "",
        },
        {
            id: 40,
            title: "Private Event",
            date: new Date("March 1, 2024 18:00:00"),
            venue: venueInfo.privateEvent,
            description: "",
        },
        {
            id: 39,
            title: "Malones Presents Salty",
            date: new Date("January 27, 2024 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 38,
            title: "Salty New Year @ Hills",
            date: new Date("January 5, 2024 21:00:00"),
            venue: venueInfo.hillsPubAndGrill,
            description: "",
        },
        {
            id: 37,
            title: "Salty's secret Santa @ Malones",
            date: new Date("December 9, 2023 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 36,
            title: "Salty @ Hills Pub and Grill",
            date: new Date("November 24, 2023 21:00:00"),
            venue: venueInfo.hillsPubAndGrill,
            description: "",
        },
        {
            id: 35,
            title: "OktoberSalt @ Malones",
            date: new Date("October 21, 2023 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 34,
            title: "Salty & the Hills",
            date: new Date("September 9, 2023 21:00:00"),
            venue: venueInfo.hillsPubAndGrill,
            description: "",
        },
        {
            id: 33,
            title: "Salty @ The Linsmore Tavern",
            date: new Date("September 1, 2023 21:30:00"),
            venue: venueInfo.linsmoreTavern,
            description: "",
        },
        {
            id: 32,
            title: "Salty live @ Hills Pub",
            date: new Date("August 26, 2023 21:00:00"),
            venue: venueInfo.hillsPubAndGrill,
            description: "",
        },
        {
            id: 31,
            title: "Salty Seasons @ Malones",
            date: new Date("August 19, 2022 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 30,
            title: "Salty live @ Hills Pub",
            date: new Date("June 23, 2023 21:00:00"),
            venue: venueInfo.hillsPubAndGrill,
            description: "",
        },
        {
            id: 29,
            title: "Get Salty at Malones",
            date: new Date("May 19, 2023 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 28,
            title: "Salty live @ Hills Pub",
            date: new Date("March 11, 2023 21:00:00"),
            venue: venueInfo.hillsPubAndGrill,
            description: "",
        },
        {
            id: 27,
            title: "Salty Loves Malones",
            date: new Date("March 4, 2023 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 26,
            title: "New Salt 2023",
            date: new Date("January 7, 2023 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 25,
            title: "Salty September @ Malones",
            date: new Date("September 16, 2022 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 24,
            title: "Salty @ Georgian Bay Park",
            date: new Date("August 20, 2022 19:00:00"),
            venue: venueInfo.georgianBayPark,
            description: "",
        },
        {
            id: 23,
            title: "School's out / Salty's in @ The Linsmore Tavern",
            date: new Date("June 30, 2022 20:00:00"),
            venue: venueInfo.linsmoreTavern,
            description: "",
        },
        {
            id: 22,
            title: "Summer of SALT",
            date: new Date("June 17, 2022 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 21,
            title: "SALTY Returns!",
            date: new Date("Oct 15, 2021 18:00:00"),
            venue: venueInfo.malones,
            description: "",
        },
        {
            id: 20,
            title: "Salty LIVE! at Malones",
            date: new Date("November 9, 2019 20:00:00"),
            venue: venueInfo.malones,
            description: ""
        },
        {
            id: 19,
            title: "Anniversary Party (private engagement)",
            date: new Date("September 1, 2019 20:00:00"),
            venue: venueInfo.privateEvent,
            description: ""
        },
        {
            id: 18,
            title: "Salty LIVE! at Malones",
            date: new Date("August 24, 2019 20:00:00"),
            venue: venueInfo.malones,
            description: ""
        },
        {
            id: 17,
            title: "Salty at Bayview Wildwood Resort",
            date: new Date("August 10, 2019 21:00:00"),
            venue: venueInfo.bayviewWildWoodResort,
            description: ""
        },
        {
            id: 16,
            title: "Salty at Bayview Wildwood Resort",
            date: new Date("July 27, 2019 21:00:00"),
            venue: venueInfo.bayviewWildWoodResort,
            description: ""
        },
        {
            id: 15,
            title: "Salty at Malone's",
            date: new Date("May 31, 2019 18:00:00"),
            venue: venueInfo.malones,
            description: ""
        },
        {
            id: 14,
            title: "Get Salty at Col. Mustard's",
            date: new Date("Jan 5, 2019 21:00:00"),
            venue: venueInfo.colonelMustards,
            description: ""
        },
        {
            id: 13,
            title: "Have a Salty New Year 2019",
            date: new Date("Dec 31, 2018 21:00:00"),
            venue: venueInfo.shamRocks,
            description: ""
        },
        {
            id: 12,
            title: "Salty Roars at the Lion and Unicorn",
            date: new Date("Nov 24, 2018 21:00:00"),
            venue: venueInfo.lionAndUnicorn,
            description: ""
        },
        {
            id: 11,
            title: "Salty's Fall 2018 Rock Review",
            date: new Date("Nov 10, 2018 20:00:00"),
            venue: venueInfo.shamRocks,
            description: ""
        },
        {
            id: 10,
            title: "Salty Rocks Shamrocks",
            date: new Date("May 26, 2018 21:00:00"),
            venue: venueInfo.shamRocks,
            description: ""
        },
        {
            id: 9,
            title: "Salty St.Pat's at Lion & Unicorn",
            date: new Date("March 17, 2018 21:00:00"),
            venue: venueInfo.lionAndUnicorn,
            description: ""
        },
        {
            id: 8,
            title: "Salty New Year's 2018 Bash",
            date: new Date("Dec 31, 2017 21:00:00"),
            venue: venueInfo.shamRocks,
            description: ""
        },
        {
            id: 7,
            title: "Salty Shakes The Lion & Unicorn",
            date: new Date("Oct 27, 2017 21:00:00"),
            venue: venueInfo.lionAndUnicorn,
            description: ""
        },
        {
            id: 6,
            title: "Salty Live! at Shamrocks",
            date: new Date("Oct 14, 2017 21:00:00"),
            venue: venueInfo.shamRocks,
            description: ""
        },
        {
            id: 5,
            title: "Salty Summer Smashup at Shamrocks!",
            date: new Date("July 29, 2017 21:00:00"),
            venue: venueInfo.shamRocks,
            description: ""
        },
        {
            id: 4,
            title: "Salty Live at Shamrocks!",
            date: new Date("June 24, 2017 21:00:00"),
            venue: venueInfo.shamRocks,
            description: ""
        },
        {
            id: 3,
            title: "Salty LIVE at Shamrocks!",
            date: new Date("April 8, 2019 21:00:00"),
            venue: venueInfo.shamRocks,
            description: ""
        },
        {
            id: 2,
            title: "Guinness Book Longest Continuous Concert",
            date: new Date("March 21, 2017 23:00:00"),
            venue: venueInfo.earlOfWhitchurch,
            description: ""

        },
        {
            id: 1,
            title: "Salty - Live in Whitby",
            date: new Date("March 2, 2017 20:00:00"),
            venue: venueInfo.shamRocks,
            description: ""
        },
    ]

    var returnEvents: { upcoming: Array<EventData>, past: Array<EventData> } = {
        upcoming: [],
        past: []
    }

    var now = new Date();
    for (var i = 0; i < events.length; i++) {
        if (events[i].date < now) {
            returnEvents.past.push(events[i]);
        }
        else {
            returnEvents.upcoming.push(events[i]);
        }
    }

    // return upcoming events in ascending order
    returnEvents.upcoming.reverse();

    return returnEvents;
}

function getNextEvent(inputDate?: Date): EventData {
    var eventData = getData();
    var nextEvent = eventData.upcoming[0];

    return nextEvent;
}

export { getData, getNextEvent };